import script from "./HighlightGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightGrid.vue?vue&type=script&setup=true&lang=js"

import "./HighlightGrid.vue?vue&type=style&index=0&id=1539c2e3&lang=scss"

const __exports__ = script;

export default __exports__